module Client.Admin.UnlockUser.Edit

open Shared
open Shared.Admin.LockUser
open Client
open Illy.SafeStack.Client
open Shared.Admin.UnlockUser
open Fable.React
open Fable.React.Props

type Model = 
    {
        UserId: UserId 
        GeneralError: string option
        Saving: bool
    }

module Validations = 
    open Illy.SafeStack.Validation
    open Illy.SafeStack.CompositionalValidation
    open Shared.Admin.UnlockUser.Validations

    let resetValidations (m: Model) = 
        {m with 
            GeneralError = None
        }

    let dispatchValidations model = 
        let model = resetValidations model 
        function 
        | ValidationResult.Passed -> model 
        | ValidationResult.Warned _ -> failwith "Did not expect warnings"
        | ValidationResult.Failed (err, _) ->
            let errors = List.map UnlockValidations.toString err
            {model with 
                GeneralError = concatOptional errors
            }

type Msg = 
    | ApiError of ApiError
    | SaveResult of FailureReason option
    | CloseOverlay  
    | SaveClicked 

type Event = 
    | CloseOverlay 
    | ApiError of ApiError 
    | SaveSuccessful of notification: string 

let init userId = 
    {
        UserId = userId 
        GeneralError = None
        Saving = false
    }, []

let update msg model = 
    match msg with 
    | Msg.ApiError err -> model, err |> ApiError |> SideEffect.Event 
    | Msg.CloseOverlay -> model, CloseOverlay |> SideEffect.Event 
    | SaveClicked -> 
        {model with Saving = true},
        Api.secureCall<IUnlockUserApi,_,_,_> SecuredRoute.Admin (fun api -> api.unlock) model.UserId SaveResult Msg.ApiError
        |> SideEffect.Cmd
    | SaveResult reason -> 
        match reason with 
        | None
        | Some NothingToDo -> model, "User was unlocked successfully." |> Event.SaveSuccessful |> SideEffect.Event
        | Some (FailedValidations v) ->
            Validations.dispatchValidations {model with Saving = false} v, SideEffect.none

let view model dispatch = 
    jQueryUI.modal "Unlock User" 50 Msg.CloseOverlay dispatch (Some 800) [
        yield jQueryUI.illy_info [
            str "Are you sure you want to unlock this user?"
        ]
        yield UI.renderError model.GeneralError
        yield! UI.saveControls (Some "Unlock User") false model.Saving SaveClicked Msg.CloseOverlay dispatch
    ]